// extracted by mini-css-extract-plugin
export default {"flexCenter":"flexCenter__zhJTR","excludeLabelContainer":"excludeLabelContainer__WUhux","redBox":"redBox__oJGoH","redRow":"redRow__xj2yD","warningIcon":"warningIcon__iFDnW"};